import React, { Component } from 'react'
import './stylesheets/notificationFront.css'
import Header from '../../components/header/Header'
import {getNotification} from '../../modules/serverCall'
import "react-datepicker/dist/react-datepicker.css";
import { Offline, Online } from "react-detect-offline";
import DatePicker from 'react-datepicker';
import { Link  } from 'react-router-dom';



 
export default class NotificationFront extends Component {
  constructor(props) {
    super(props);
    let params = new URLSearchParams(window.location.pathname);
    var monthSaveData = params.get("month");
    var notificationDataMain = JSON.parse(localStorage.getItem('notificationData'));
    if(notificationDataMain !=='' && notificationDataMain !==null && notificationDataMain !== undefined){
      // if(monthSaveData !=='' && monthSaveData !== null && monthSaveData !== undefined){
      //   jobDataMain ='';
      // }else{
        notificationDataMain = JSON.parse(localStorage.getItem('notificationData'));
      // }
    }
    this.state = {
      currnetmonthdata:'',
      currnetmonth:'',
      currnetyear:'',
      customerid:'',
      notificationDataMain: notificationDataMain
    }
  }


 

  componentDidMount () {
    window.scrollTo(0, 0);
    var month = '';
    var currentCount = '';
    var monthData ='';
    var year = '';
    const accesstokendata =  localStorage.getItem('access_token');
    const readData = JSON.parse(accesstokendata);
    const cusId =  readData.userdata.user_id;
    let params = new URLSearchParams(window.location.pathname);
    var monthSaveData = params.get("month");
    if(monthSaveData !=='' && monthSaveData !== null && monthSaveData !== undefined){
      monthData = params.get("month");
      year = params.get("year");
      var newDate = params.get("jobdate");
      var sendData = {
        month:monthData,
        year:year,
        techId:cusId
      }
      this.setState({ currnetyear:year,currnetmonthdata:new Date(newDate) ,currnetmonth:monthData});
      const fetchnotification = async () => {
      const responsenotification = await getNotification(sendData);
      const datarespnotification  = await responsenotification;
        this.setState({
          notificationDataMain:datarespnotification
        });
      };
      fetchnotification();
    }else{
      month = new Date().getMonth();
      currentCount = parseInt(month);
      monthData = currentCount + 1;
      year = (new Date()).getFullYear();
      
      var sendData = {
          month:monthData,
          year:year,
          techId:cusId
      }
      const fetchnotification = async () => {
        const responsenotification = await getNotification(sendData);
        const datarespnotification  = await responsenotification;
          this.setState({
            notificationDataMain:datarespnotification
          });
        };
        fetchnotification();

      this.setState({ currnetmonthdata: new Date(),currnetyear:year,
        customerid:cusId,currnetmonth:monthData});
    }
  }

  // handleChange = event => {
  //   var month = new Date().getMonth();
  //   var currentCount = parseInt(month);
  //   var monthData = currentCount + 1;
  //   var year = (new Date()).getFullYear();
  //   const accesstokendata =  localStorage.getItem('access_token');
  //   const readData = JSON.parse(accesstokendata);
  //   const cusId =  readData.userdata.user_id;
  //   var sendData = {
  //       month:monthData,
  //       year:year,
  //       techId:cusId
  //   }
  //   this.setState({ currnetyear:year,customerid:cusId,currnetmonth:monthData});
  //   const fetchjobs = async () => {
  //   const responsejobs = await getJobs(sendData);
  //   const datarespjobs  = await responsejobs;
  //     this.setState({
  //       jobDataMain:datarespjobs
  //     });
  //   };
  //   fetchjobs();
    
  // }

  // handleInputChange = event => {
  //   this.setState({ currnetmonthdata: event});
  //   var monthData = event.getMonth();
  //   var year = (event).getFullYear();
  //   const accesstokendata =  localStorage.getItem('access_token');
  //   const readData = JSON.parse(accesstokendata);
  //   const cusId =  readData.userdata.user_id;
  //   var sendData = {
  //       month:monthData + 1,
  //       year:year,
  //       techId:cusId
  //   }
  //   this.setState({ currnetyear:year,customerid:cusId,currnetmonth:monthData+ 1});
  //   const fetchjobs = async () => {
  //     const responsejobs = await getJobs(sendData);
  //       const datarespjobs  = await responsejobs;
  //       this.setState({
  //         jobDataMain:datarespjobs
  //       });
  //     };
  //     fetchjobs();
  // }

  render() {
    var searchDropMain = this.state.notificationDataMain;
    var currnetMonth = '';
    var currnetMonthData = this.state.currnetmonthdata;
    var onLineStatus = navigator.onLine;

    if(currnetMonthData === ''){
      currnetMonth = new Date();
    }else{
      currnetMonth = currnetMonthData;
    }
    
    if(searchDropMain !=='' && searchDropMain !==null && searchDropMain !== undefined){
      searchDropMain = JSON.parse(localStorage.getItem('notificationData'));
    }

    return (
      <div>
      <Header/>
        <div className="topconw">
        <div className="row row-mywork paddClass">
            <div className="col-md-12 alignDataCenter">
                <div className="d-flex flex-row justify-content-between align-items-center filters">
                    <h2><b className="MyWorkNoti">Notification</b></h2>
                    <div className="right-sort">
                        {/* <div className="sort-by">
                        <DatePicker
                            selected={currnetMonth}
                            onChange={(date) => this.handleInputChange(date)}
                            dateFormat="MMM yyyy"
                            showMonthYearPicker
                            className="input-date-data"
                          />
                      </div> */}
                    </div>
                </div>
            </div>
        </div>
        {onLineStatus === true ? 
            <div className="row mt-1 boxAlign boxAlignMyWork paddClass">
              {searchDropMain!== '' && searchDropMain !== null && searchDropMain !== undefined ?
                              searchDropMain.map((notificationdata,index) => (
                  <Link className={notificationdata.ReadFlag === 0 ? "cardMainNotiUnRead" : "cardMainNoti"} to={'/notification-details/&notificationID='+notificationdata.NotificationID} key={index +1 }><div className="col-md-4" key={index}>
                      <div className="p-card rounded px-3" >
                        <span key={index +3 } className="d-block">{notificationdata.DisplayFromDate}</span>
                        <p key={index +2 } className="mt-2">{notificationdata.Notification !== '' && notificationdata.Notification !== null && notificationdata.Notification !== undefined ? notificationdata.Notification.substring(0,3)+'....' : notificationdata.Notification}</p>
                    </div>
                  </div></Link>
               )):""
             }
            </div>
        :
        <div className="row mt-1 boxAlign boxAlignMyWork">
          {searchDropMain !== '' && searchDropMain !== null  && searchDropMain !== undefined ?
                                searchDropMain.map((notificationdata,index) => (
                    <div className="col-md-4 cardMainData cardMainDataMyWork" key={index}>
                        <div className="p-card rounded px-3">
                        <span key={index +3 } className="d-block">{notificationdata.DisplayFromDate}</span>
                        <p key={index +2 } className="mt-2">{notificationdata.Notification !== '' && notificationdata.Notification !== null && notificationdata.Notification !== undefined ? notificationdata.Notification.substring(0,3)+'....' : notificationdata.Notification}</p>
                      </div>
                    </div>
                 )):""
               }
        </div>
      }
        {/* <div className="row mt-1 boxAlign boxAlignMyWork">

          <Online>
            {searchDropMain!== '' && searchDropMain !== null && searchDropMain !== undefined ?
                              searchDropMain.map((notificationdata,index) => (
                  <Link className={notificationdata.ReadFlag === 0 ? "cardMainNotiUnRead" : "cardMainNoti"} to={'/notification-details/&notificationID='+notificationdata.NotificationID} key={index +1 }><div className="col-md-4" key={index}>
                      <div className="p-card rounded px-3" >
                        <span key={index +3 } className="d-block">{notificationdata.DisplayFromDate}</span>
                        <p key={index +2 } className="mt-2">{notificationdata.Notification !== '' && notificationdata.Notification !== null && notificationdata.Notification !== undefined ? notificationdata.Notification.substring(0,3)+'....' : notificationdata.Notification}</p>
                    </div>
                  </div></Link>
               )):""
             }
            </Online>
            <Offline>
              {searchDropMain !== '' && searchDropMain !== null  && searchDropMain !== undefined ?
                                searchDropMain.map((notificationdata,index) => (
                    <div className="col-md-4 cardMainData cardMainDataMyWork" key={index}>
                        <div className="p-card rounded px-3">
                        <span key={index +3 } className="d-block">{notificationdata.DisplayFromDate}</span>
                        <p key={index +2 } className="mt-2">{notificationdata.Notification !== '' && notificationdata.Notification !== null && notificationdata.Notification !== undefined ? notificationdata.Notification.substring(0,3)+'....' : notificationdata.Notification}</p>
                      </div>
                    </div>
                 )):""
               }
            </Offline>
          </div> */}
        </div>
      </div>

    )
  }
}





